export default __webpack_public_path__ + "static/Sampension1200-a59af8a526b0bf3967f6199e1863aa19.jpg";